import { Moon, Sun } from "lucide-react";

import { cn } from "@/lib/utils";
import { toggleTheme, useTheme } from "@/lib/theme";

/**
 * Light/Dark theme switch — the moon/sun pill in the top nav. Reads and flips
 * the global `data-theme` on <html> (see lib/theme.ts); every surface re-skins
 * off the shared tokens in index.css, so nothing else needs to change.
 *
 * Not shown on the main landing page ("/") or the auth pages — those stay on
 * the Dark · Gold signature look with no theme option.
 */
export default function ThemeToggle({ className }: { className?: string }) {
  const theme = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={isDark ? "Switch to light theme" : "Switch to dark theme"}
      title={isDark ? "Switch to light theme" : "Switch to dark theme"}
      className={cn(
        "inline-flex items-center gap-2 rounded-full border border-border/80 bg-card px-3 py-1.5 text-sm font-semibold text-foreground transition-colors duration-200 hover:bg-accent",
        className
      )}
    >
      {isDark ? (
        <Moon className="h-4 w-4 text-primary" />
      ) : (
        <Sun className="h-4 w-4 text-primary" />
      )}
      <span className="hidden sm:inline">{isDark ? "Dark" : "Light"}</span>
    </button>
  );
}
